(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('labours', {
        templateUrl: 'views/components/views/labours/labours.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'utilityService', 'laboursService', 'rememberService', 'idServerService', 'ttGridFactory', function (stateService, utilityService, laboursService, rememberService, idServerService, ttGridFactory) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;

            let variableNames = {
                activestatus: '',
                gb_labourtype: '',
                searchtext: ''
            };

            vm.model = {
                gridReady: false,
                bgTypes: {
                    selected: 'ACT',
                    buttons: [
                        { id: 'ACT', label: 'active', color: 'primary', onClick: () => setTypesView('ACT') },
                        { id: 'NOT_ACT', label: 'not_active', color: 'primary', onClick: () => setTypesView('NOT_ACT') },
                        { id: 'ALL', label: 'all', color: 'primary', onClick: () => setTypesView('ALL') }
                    ]
                },
                bgLabourType: {
                    selected: 'INTERNAL',
                    buttons: [
                        { id: 'INTERNAL', label: 'gb_labourtype_internal', color: 'primary', onClick: () => setLabourTypeView('INTERNAL') },
                        { id: 'EXTERNAL', label: 'gb_labourtype_external', color: 'primary', onClick: () => setLabourTypeView('EXTERNAL') }
                    ]
                },
                searchTextButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') },
                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => searchLabours() }
                ],
                service: laboursService,
                setting: {}
            };

            vm.grid = new ttGridFactory({
                rememberId: 'w_labours.grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setCustomToolbarButtons([{
                name: 'add_new_labour',
                text: 'add_new_labour',
                func: () => stateService.go('labouredit', { labour_no: '0' }),
                icon: 'fa-plus',
                cssClass: 'btn btn-primary im-grid-btn-xs-r',
                translate: true
            }]);

            // #endregion VARIABLES & DEFINITIONS

            // #region SET BUTTON RADIO VALUE FUNCTIONS

            function setTypesView(id) {
                vm.model.bgTypes.selected = vm.model.setting.activestatus = id;
            }
            
            function setLabourTypeView(id) {
                vm.model.bgLabourType.selected = vm.model.setting.gb_labourtype = id;
            }

            // #endregion SET BUTTON RADIO VALUE FUNCTIONS

            // #region LOAD PROCEDURE FUNCTION CALL

            async function loadSetting() {
                vm.model.setting = (await laboursService.getSetting())[0];

                setTypesView(vm.model.setting.activestatus);
                setLabourTypeView(vm.model.setting.gb_labourtype);

                return loadGrid();
            }

            // #endregion LOAD PROCEDURE FUNCTION CALL

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                idServerService.currentUserDetails().then(function (loggedInUser) {
                    if (angular.isObject(loggedInUser) !== true) return;
                    if (angular.isDefined(loggedInUser.userName) !== true) return;
                    if (loggedInUser.canAccessClient !== true) return;
                    if (loggedInUser.isCompanyAdmin !== true) return;
                });

                if (utilityService.validateParmsValue(vm.model.setting.activestatus) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.gb_labourtype) !== true) return;
                if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

                vm.grid.dataTask.loadData = {
                    method: 2492,
                    parameters: vm.model.setting
                };

                vm.model.gridReady = true;

                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'activestatus':
                    case 'gb_labourtype':
                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    case 'searchtext':
                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }
            
            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS
            
            // #region RESET BUTTON FUNCTION

            function clear(id) {
                switch (id) {
                    case 'searchtext':
                        vm.model.setting.searchtext = '';

                        if (vm.model.setting.searchtext === '') searchLabours();
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region SEARCH LABOUR FUNCTION

            function searchLabours() {
                return Promise.all([
                    rememberFunc('searchtext')
                ]).then(() => {
                    loadGrid();
                    Promise.resolve();
                });

                return Promise;
            }

            vm.searchItems = function () {
                searchLabours();
            };

            // #endregion SEARCH LABOUR FUNCTION

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgTypes = function (value) {
                vm.model.bgTypes.selected = value;
                vm.model.setting.activestatus = vm.model.bgTypes.selected;

                return Promise.all([
                    rememberFunc('activestatus')
                ]).then(() => {
                    loadGrid();
                    Promise.resolve();
                });

                return Promise;
            };
            
            vm.selectBgLabourType = function (value) {
                vm.model.bgLabourType.selected = value;
                vm.model.setting.gb_labourtype = vm.model.bgLabourType.selected;

                return Promise.all([
                    rememberFunc('gb_labourtype')
                ]).then(() => {
                    loadGrid();
                    Promise.resolve();
                });

                return Promise;
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // #region ON BLUR MULTI FUNCTIONS

            vm.onBlur = function (id) {
                switch (id) {
                    case 'searchtext':
                        if (utilityService.validateParmsValue(vm.model.setting.searchtext) !== true) return;

                        if (vm.model.setting.searchtext > '') searchLabours();
                        break;
                    default:
                        break;
                }
            };

            // #endregion ON BLUR MULTI FUNCTIONS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'searchtext':
                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

                        vm.model.setting.searchtext = value;

                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;
                        
                        if (vm.model.setting.searchtext === '') searchLabours();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
